import React from "react";
import Table from "@mui/material/Table";
import StickyPaperTableContainer from "component/sticky/StickyPaperTableContainer";
import { EntityIdentifier } from "module/entity/types";
import MaintenanceTaskProcessStepListTableHeadContainer from "module/maintenanceTaskProcessStep/enrichedComponent/tableHead/MaintenanceTaskProcessStepListTableHeadContainer";
import MaintenanceTaskProcessStepListRowContainer from "module/maintenanceTaskProcessStep/enrichedComponent/tableRow/MaintenanceTaskProcessStepListRowContainer";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import TableBody from "component/table/tableBody/TableBody";
import MaintenanceTaskProcessStepContextProvider from "module/maintenanceTaskProcessStep/context/MaintenanceTaskProcessStepContextProvider";

interface Props {
  entityIdentifiers: EntityIdentifier[];
}

const MaintenanceTaskToBeSignedProcessStepList: React.FC<Props> = ({
  entityIdentifiers,
}) => {
  return (
    <StickyPaperTableContainer>
      <Table stickyHeader>
        <MaintenanceTaskProcessStepListTableHeadContainer />
        <TableBody>
          {entityIdentifiers.map((entityIdentifier) => (
            <MaintenanceTaskProcessStepContextProvider
              {...{
                entityIdentifier,
                key: getEntityIdentifierKey(entityIdentifier),
              }}
            >
              <MaintenanceTaskProcessStepListRowContainer
                key={getEntityIdentifierKey(entityIdentifier)}
              />
            </MaintenanceTaskProcessStepContextProvider>
          ))}
        </TableBody>
      </Table>
    </StickyPaperTableContainer>
  );
};

export default React.memo(MaintenanceTaskToBeSignedProcessStepList);
